import './index.css'
import {Component} from 'react'
import {FaMoon, FaRegLightbulb} from 'react-icons/fa'
import Cookies from 'js-cookie'
import {withRouter, Link} from 'react-router-dom'
import Popup from 'reactjs-popup'
import 'reactjs-popup/dist/index.css'

class Headers extends Component {
  onLogout = () => {
    const {history} = this.props
    Cookies.remove('jwt_token')
    history.replace('/login')
  }

  render() {
    const {theme, toggleTheme} = this.props

    const backgroundImage = theme
      ? 'https://assets.ccbp.in/frontend/react-js/nxt-watch-logo-dark-theme-img.png'
      : 'https://assets.ccbp.in/frontend/react-js/nxt-watch-logo-light-theme-img.png'

    return (
      <div className="header">
        <Link to="/">
          <img src={backgroundImage} alt="website logo" className="logo" />
        </Link>

        <div className="theme">
          <button
            type="button"
            data-testid="theme"
            onClick={toggleTheme}
            className="theme-button"
          >
            {theme ? (
              <FaRegLightbulb className="moon" />
            ) : (
              <FaMoon className="moon" />
            )}
          </button>

          <img
            src="https://assets.ccbp.in/frontend/react-js/nxt-watch-profile-img.png"
            alt="profile"
            className="profile"
          />
          <Popup
            modal
            trigger={
              <button type="button" className="button">
                Logout
              </button>
            }
          >
            {close => (
              <div className="popup-content">
                <p>Are you sure, you want to logout</p>
                <div className="popup-buttons">
                  <button
                    type="button"
                    className="confirm-btn"
                    onClick={this.onLogout}
                  >
                    Confirm
                  </button>
                  <button type="button" className="cancel-btn" onClick={close}>
                    Cancel
                  </button>
                </div>
              </div>
            )}
          </Popup>
        </div>
      </div>
    )
  }
}

export default withRouter(Headers)
